export default __webpack_public_path__ + "static/media/main.72a59557.jpg";